



















































































































































































import Vue from 'vue'
import api from '../../../api'

export default Vue.extend({
  props: {
    reimbursement: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      loading: false,
      error: null as string | null,
      kkiapayResponse: null as any,
      showFullJson: false
    }
  },

  computed: {
    formattedJson(): string {
      return JSON.stringify(this.kkiapayResponse, null, 2)
    },

    parsedError(): {
      status: string
      errorReasons: any[]
      transactionId: string
    } {
      if (!this.kkiapayResponse)
        return { status: '', errorReasons: [], transactionId: '' }

      const status = this.kkiapayResponse.status || 'N/A'
      const errorReasons: any[] = []
      const transactionId =
        this.kkiapayResponse.externalTransactionId ||
        this.kkiapayResponse.transactionId ||
        this.kkiapayResponse._id ||
        ''

      if (
        this.kkiapayResponse.errorReasons &&
        Array.isArray(this.kkiapayResponse.errorReasons)
      ) {
        errorReasons.push(...this.kkiapayResponse.errorReasons)
      }

      if (
        this.kkiapayResponse.stateData?.errorReasons &&
        Array.isArray(this.kkiapayResponse.stateData.errorReasons)
      ) {
        errorReasons.push(...this.kkiapayResponse.stateData.errorReasons)
      }

      if (
        this.kkiapayResponse.rawhistory &&
        Array.isArray(this.kkiapayResponse.rawhistory)
      ) {
        this.kkiapayResponse.rawhistory.forEach((history: any) => {
          try {
            const historyData =
              typeof history === 'string' ? JSON.parse(history) : history
            if (historyData.response?.body) {
              const body = historyData.response.body
              if (body.message || body.description) {
                errorReasons.push({
                  status: body.status,
                  message: body.message || body.description
                })
              }
            }
          } catch (e) {
            // Ignore parsing errors
          }
        })
      }

      return { status, errorReasons, transactionId }
    }
  },

  methods: {
    async verifyTransaction() {
      this.loading = true
      this.error = null
      try {
        const response = await api.get(
          `/reimbursements/${this.reimbursement.id}/verify-kkiapay`
        )
        if (response.data.error) {
          this.error = response.data.error
        } else {
          this.kkiapayResponse = response.data.kkiapayResponse
        }
      } catch (err) {
        this.error =
          err.response?.data?.message || 'Erreur lors de la vérification'
      } finally {
        this.loading = false
      }
    },

    copyToClipboard() {
      const text = this.formattedJson
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(() => {
          this.$notify.success('JSON copié dans le presse-papier')
        })
      }
    }
  },

  mounted() {
    this.verifyTransaction()
  }
})
